// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const AddAdmin = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M40 9.696c0 4.5-3.233 8.246-7.502 9.04.454 1.5.698 3.089.698 4.734 0 9.014-7.334 16.348-16.348 16.348S.5 32.484.5 23.47c0-9.015 7.334-16.348 16.348-16.348 1.72 0 3.38.267 4.938.762A9.196 9.196 0 0 1 40 9.696ZM31.54 23.47c0-1.598-.256-3.136-.73-4.578h-.006a9.196 9.196 0 0 1-9.196-9.323 14.632 14.632 0 0 0-4.76-.792c-8.102 0-14.693 6.591-14.693 14.693 0 4.412 1.958 8.373 5.048 11.069.55-3.466 2.932-6.328 6.118-7.566a6.815 6.815 0 0 1-3.292-5.826c0-3.76 3.059-6.82 6.819-6.82s6.82 3.06 6.82 6.82c0 2.469-1.324 4.629-3.293 5.826 3.186 1.238 5.567 4.1 6.118 7.566 3.09-2.696 5.047-6.657 5.047-11.07Zm4.269-12.925a.966.966 0 0 0 0-1.931h-4.04V4.69a.966.966 0 0 0-1.931 0v3.924h-4.04a.966.966 0 0 0 0 1.93h4.04v3.924a.966.966 0 0 0 1.93 0v-3.923h4.04Z"
			fill="#555BE4"
		/>
	</svg>
);
export default AddAdmin;
